













import { Vue, Component, PropSync } from 'vue-property-decorator'

import reasons from '@/reasons'

@Component
export default class WhatWentWrong extends Vue {
  @PropSync('category', { required: false })
  private categorySynced!: string | null

  @PropSync('reason', { required: false })
  private reasonSynced!: string | null

  private get reasons () {
    return reasons
  }
}
